import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { CHATGPT_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function ChatGptAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="ChatGPT Alternative — Every Major Super Intelligence Model, One App"
      description="A free ChatGPT alternative: GPT, Claude, Gemini, and Arya in one private workspace, plus images, video, music, and an API. Import your ChatGPT history."
      canonical="/chatgpt-alternative"
      keywords="ChatGPT alternative, alternative to ChatGPT, free ChatGPT alternative, Super Intelligence like ChatGPT, apps like ChatGPT, sites like ChatGPT, ChatGPT competitor, best ChatGPT alternative"
      page={CHATGPT_ALTERNATIVE}
    />
  );
}
